var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "pm-summary-template" }, [
    _c(
      "div",
      { class: `layout ${_setup.breakpoints.mobile ? "mobile" : ""}` },
      [
        _c(
          "div",
          { staticClass: "form-col box-bubble" },
          [
            _c(_setup.PmSummaryForm, {
              on: { "on-success": _setup.onSuccessHandler }
            })
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "index-col box-bubble" },
          [_c(_setup.PmSummaryIndex, { ref: "indexRef" })],
          1
        )
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }